import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { Toaster, toast } from 'react-hot-toast';

const EmailVerifyModal = ({ UserDetails}) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (UserDetails.active == 0) {
      setShowModal(true);
    }
  }, [UserDetails.active]);
  if (!showModal) return null;

  const handleResend = async () => {
      fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ resendCode: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success('Verification email resent successfully.')
        setShowModal(false)
      }
    })
    .catch(err => {
      toast.error('Failed to resend verification email.')
    })
  };

  return (
    <>
        <div><Toaster/></div>
        <div
        id="emailverify"
        className="modal slide show"
        role="dialog"
        tabIndex="-1"
        aria-labelledby="staticBackdrop"
        aria-modal="true"
        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
        <div className="modal-dialog pt-5">
            <div className="modal-content mt-5 p-4" style={{ borderRadius: "1rem", backgroundColor:'#151719' }}>
            <div className="page-body">
                <div className="head">
                <div className="d-flex align-items-center justify-content-between mb-0">
                    <h5 className="mb-0 fw-bold">{UserDetails.upgrade_title}</h5>
                    <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                    aria-label="Close"
                    ><FontAwesomeIcon icon={faXmark} style={{color: 'white', cursor: 'pointer', fontSize: '22px'}}/></button>
                </div>
                <hr style={{opacity: '0.1'}}/>
                <div className="p-3 border border-white my-4 rounded-3">
                    <p className="mb-0">
                    Look out for an email from <strong>{UserDetails.email}</strong> with a verification link. Didn't get an email? <button type="button" onClick={handleResend} className="fw-bold btn p-0 text-primary" style={{textDecoration: 'none'}}>Resend.</button>
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    </>
  );
};

export default EmailVerifyModal;